import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface MaterialItem {
  id: string;
  name: string;
  category: "Structure" | "Envelope" | "Finishes" | "Bulk";
  quantity: number;
  unit: string;
  step: number;
  unitCost: number;
}

const SEED: MaterialItem[] = [
  { id: "concrete", name: "Concrete 25MPa", category: "Structure", quantity: 210, unit: "m³", step: 1, unitCost: 2450 },
  { id: "rebar", name: "Rebar Steel Y12", category: "Structure", quantity: 12, unit: "t", step: 0.5, unitCost: 18900 },
  { id: "brick", name: "Clay Brick NFP", category: "Envelope", quantity: 48000, unit: "units", step: 500, unitCost: 3.85 },
  { id: "timber", name: "SA Pine Timber", category: "Structure", quantity: 6.5, unit: "m³", step: 0.5, unitCost: 9800 },
  { id: "roofing", name: "IBR Roofing 0.5mm", category: "Envelope", quantity: 320, unit: "m²", step: 10, unitCost: 215 },
  { id: "glazing", name: "Glazing 6mm Clear", category: "Envelope", quantity: 96, unit: "m²", step: 2, unitCost: 1150 },
  { id: "cement", name: "Cement 42.5N", category: "Bulk", quantity: 640, unit: "bags", step: 20, unitCost: 118 },
  { id: "sand", name: "Building Sand", category: "Bulk", quantity: 85, unit: "m³", step: 5, unitCost: 420 },
  { id: "plaster", name: "Plaster & Skim", category: "Finishes", quantity: 1100, unit: "m²", step: 50, unitCost: 165 },
];

interface MaterialsState {
  items: MaterialItem[];
  recalculateMaterialItem: (id: string, quantity: number) => void;
  resetMaterials: () => void;
}

export const useMaterialsStore = create<MaterialsState>()(
  persist(
    (set) => ({
      items: SEED,
      recalculateMaterialItem: (id, quantity) =>
        set((s) => ({
          items: s.items.map((m) => (m.id === id ? { ...m, quantity: Math.max(0, roundTo(quantity, m.step)) } : m)),
        })),
      resetMaterials: () => set({ items: SEED }),
    }),
    { name: "buildease.materials" },
  ),
);

const roundTo = (v: number, step: number) => {
  const d = step < 1 ? 2 : 0;
  return Number(v.toFixed(d));
};

export const itemCost = (m: MaterialItem) => m.quantity * m.unitCost;
export const selectMaterialsTotal = (s: MaterialsState) => s.items.reduce((a, m) => a + itemCost(m), 0);
export const formatQty = (m: MaterialItem) => m.quantity.toLocaleString("en-US", { maximumFractionDigits: 2 }).replace(/,/g, " ");
